export default "__VITE_ASSET__8lAXISob__"